import FontIcon from '@luminopia/react-toolbox/lib/font_icon'
import * as classnames from 'classnames'
import * as React from 'react'
import * as classNames from './styles.css'

export interface ITheme {
  container?: string
  containerActive?: string
  iconContainer?: string
  iconContainerActive?: string
  icon?: string
  iconActive?: string
  labelContainer?: string
  labelContainerActive?: string
  label?: string
  labelActive?: string
}

export interface IProps {
  icon?: string
  label?: string
  active?: boolean
  theme?: ITheme
}

class NavigationItem extends React.PureComponent<IProps, {}> {
  public render() {
    const theme: ITheme = this.props.theme || {}
    const containerClassName = classnames(
      classNames.container,
      {[classNames.containerActive || '']: this.props.active},
      theme.container,
      {[theme.containerActive || '']: this.props.active},
    )
    const iconContainerClassName = classnames(
      theme.iconContainer,
      {[theme.iconContainerActive || '']: this.props.active},
    )
    const iconClassName = classnames(
      theme.icon,
      {[theme.iconActive || '']: this.props.active},
    )
    const labelContainerClassName = classnames(
      theme.labelContainer,
      {[theme.labelContainerActive || '']: this.props.active},
    )
    const labelClassName = classnames(
      theme.label,
      {[theme.labelActive || '']: this.props.active},
    )

    return (
      <div className={containerClassName}>
        <div className={iconContainerClassName}>
          {this.props.icon && <FontIcon value={this.props.icon} className={iconClassName} />}
        </div>
        <div className={labelContainerClassName}>
          <p className={labelClassName}>{this.props.label}</p>
        </div>
      </div>
    )
  }
}

export default NavigationItem



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/NavigationItem/index.tsx